import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Globe } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NetRow = ({ name, info, active, onSwitch, busy }) => (
  <div className="flex items-center justify-between bg-slate-900 rounded-lg px-4 py-3" data-testid={`network-row-${name}`}>
    <div>
      <p className="text-white font-medium capitalize">{name} {active && <span className="ml-2 text-xs px-2 py-0.5 rounded bg-emerald-500/20 text-emerald-400">LIVE</span>}</p>
      <p className="text-xs text-slate-400">{info?.error ? 'Unreachable' : `${Number(info?.eth || 0).toFixed(4)} ETH · ${Number(info?.beth || 0).toLocaleString()} BETH in master wallet`}</p>
    </div>
    {!active && (
      <button onClick={() => onSwitch(name)} disabled={busy || !info?.ready} data-testid={`network-switch-${name}`}
        className={`px-4 py-2 rounded-lg text-sm font-medium ${info?.ready ? 'bg-emerald-500 hover:bg-emerald-600 text-white' : 'bg-slate-700 text-slate-400 cursor-not-allowed'}`}>
        {info?.ready ? `Go live on ${name}` : 'Not funded yet'}
      </button>
    )}
  </div>
);

export const AdminNetworkCard = ({ token }) => {
  const [net, setNet] = useState(null);
  const [busy, setBusy] = useState(false);
  const auth = { headers: { Authorization: `Bearer ${token}` } };

  const load = useCallback(() => axios.get(`${API}/pas-admin/network`, { headers: { Authorization: `Bearer ${token}` } }).then(r => setNet(r.data)), [token]);
  useEffect(() => { load(); }, [load]);

  const switchTo = async (name) => {
    if (!window.confirm(`Switch all live transfers to ${name}?`)) return;
    setBusy(true);
    try { const r = await axios.post(`${API}/pas-admin/network`, { network: name }, auth); toast.success(r.data.message); load(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Switch failed'); }
    finally { setBusy(false); }
  };

  if (!net) return null;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 mb-6" data-testid="admin-network-card">
      <h3 className="text-lg font-bold text-white mb-1 flex items-center gap-2"><Globe className="w-5 h-5 text-purple-400" /> Live network</h3>
      <p className="text-slate-400 text-sm mb-4">Mainnet unlocks once master wallet <span className="font-mono text-xs">{net.master_wallet}</span> holds at least {net.mainnet_min_eth} ETH and some BETH on mainnet.</p>
      <div className="space-y-2">
        {['sepolia', 'mainnet'].map(n => <NetRow key={n} name={n} info={net[n]} active={net.active === n} onSwitch={switchTo} busy={busy} />)}
      </div>
    </div>
  );
};
